
if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.section = this.closest('section');
      this.tabsButton = this.querySelectorAll('[data-collection-button]');
      this.tabsCollections = this.querySelectorAll('[data-collection-tabs]');
      this.tabsViewButton = this.section.querySelectorAll('[data-button-index]');
      this.switchBox = this.querySelector('[data-collections-buttons]');
      this.sectionHeader = this.section.querySelector('[data-section-header-wrapper]');
  
      // Ensure 'has-view-more' is added if buttons exist
      if (this.tabsViewButton && this.sectionHeader) {
        this.sectionHeader.classList.add('has-view-more');
        this.tabsViewButton.forEach(button => button.classList.remove('hidden'));
      }
  
      this.tabsButton.forEach(button => {
        button.addEventListener('click', this.handleTabClick.bind(this));
      });
  
  
      this.tabsCollections.forEach(tabs => {
        const swiperElement = tabs.querySelector('[data-swiper]');
        if (swiperElement) {
          const swiperProperties = JSON.parse(swiperElement.getAttribute('data-swiper'));
          theme.SwiperSlide(swiperElement, swiperProperties);
        }
      });
        this.onLoadSetup();    
  
    }
  
    onLoadSetup() { 
    
      if (this.tabsButton.length > 0) {
        this.tabsButton[0].click(); 
      }
    }
  
    handleTabClick(event) {
      const tabId = event.currentTarget.getAttribute('data-id');
      const triggerType = event.currentTarget.getAttribute('trigger');
      this.tabsButton.forEach(btn => btn.classList.remove('active'));
      event.currentTarget.classList.add('active');
      this.tabsContent(tabId);
      this.switchBox.style.setProperty('--tab-index', triggerType);
      this.switchBoxWidth = event.currentTarget.offsetWidth;   
      this.switchBox.style.setProperty('--tab-index-button-width', `${this.switchBoxWidth}px`); 
    }
  
  
    tabsContent(tabId) {
      this.tabsCollections.forEach(tabs => tabs.classList.remove('active'));
      this.tabsViewButton.forEach(button => button.classList.remove('active'));
      const activeTab = this.querySelector(`[data-collection="collection-tabs-${tabId}"]`);
      if (activeTab) {
        const activeButton = this.section.querySelector(`[data-button="collection-${tabId}"]`);
        if (activeButton) {
          activeButton.classList.add('active');
        }
        activeTab.classList.add('active');
      }
    }
  }
  
  customElements.define('collection-tabs', CollectionTabs);
}